import router from '@/router'
import { ElMessage } from 'element-plus'

export function errorHandler(error){
  if(error.redirectPage){
    let page = { path: error.redirectPage} 
    if(error.redirectParam){
      page['query'] = error.redirectParam
    }
    router.push(page)
  }
  if(error.message){
    ElMessage.error(error.message)
  }
}